<template>
  <div class="mian-article">
    <Header/>
    <div class="width1200">
      <div class="box">
        <h1>{{ $t('about.DevelopmentHistory') }}</h1>
        <el-timeline>
          <el-timeline-item :timestamp="i.TimeTitle" placement="top" v-for="i in isEnglish?dataList_en:dataList"
                            :key="i.index">
            <el-card>
              <div class="site">
                <img :src="i.imgs" alt="" class="site-img">
                <div class="site-info">
                  <p>{{ i.content }}</p>
                </div>
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"

export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      isEnglish: false,
      dataList: [
        {
          imgs: require('../../assets/image/aboutUs/course/1.jpeg'),
          TimeTitle: '2018年11月14日正式启动建设',
          content: "为深入贯彻落实习近平总书记视察广东重要讲话精神，大力实施创新驱动发展战略，广东省委省政府决定建设南方海洋科学与工程广东省实验室（珠海）。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/2.jpeg'),
          TimeTitle: '2018年12月26日揭牌仪式隆重举行',
          content: "举行揭牌仪式暨理事会成立大会，并召开南方海洋实验室第一届理事会第一次会议。会议审议通过由中国科学院院士陈大可担任实验室主任，中国科学院院士苏纪兰担任学术委员会主任。南方海洋实验室由珠海市人民政府举办，中山大学牵头建设和管理，实行理事会领导下的实验室主任负责制。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/3.jpeg'),
          TimeTitle: '2019年3月7日推动国际大科学计划',
          content: "主办南海季风综合科学实验筹备会议。来自中国两院的7位院士等国内外多个单位的专家和学者共120余人参加了会议。此次会议将为南海季风科学实验的实施提供以往的成功经验和建设性策略，也是南方海洋实验室主办的首次国际学术会议。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/4.jpeg'),
          TimeTitle: '2019年4月7日第一届学术委员会成立大会',
          content: "由来自中国科学院和工程院的19位院士和12位海洋领域顶尖专家组成的南方海洋实验室第一届学术委员会成立大会暨第一次会议在珠海召开。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/5.jpeg'),
          TimeTitle: '2019年6月3日首批合作共建单位签约仪式',
          content: "首批共建单位签约仪式在珠海举行。首批签约的包括自然资源部、教育部等部委科研院所和大学等12家共建单位。实验室将对标国际上最优最好最先进的海洋实验室，集聚全球创新人才。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/6.jpeg'),
          TimeTitle: '2019年4-6月持续支持南海科学考察计划',
          content: "分别成功组织“西沙综合科考航次”和“南海季风综合科考试验预演航次”。其中，西沙航次在西沙群岛羚羊礁上发现一种新的海生昆虫，并将其命名为羚羊礁海蝽。大气航段收集海洋气象数据10万余组，数据有效性达到或超过90%；物理海洋收集数据8万余组，取得了预期的观测成果。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/7.png'),
          TimeTitle: '2019年7月17日搭乘“深海勇士”开展深潜任务',
          content: "苏明副教授、何键副研究员参与了“探索一号”的第TS12-02航次。他们从海南三亚出发，前往南海北部、西北部，分别搭乘“深海勇士”号深潜器顺利完成了深潜任务。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/8.png'),
          TimeTitle: '2019年9月20日两野外观测研究站获批',
          content: "南方海洋实验室与中山大学合作共建“珠江口海洋生态环境教育部野外科学观测研究站”获教育部认定。24日，“环珠江口气候环境与空气质量变化野外科学观测研究站”获批为广东省野外科学观测研究站。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/9.jpeg'),
          TimeTitle: '2019年10月1日南方海洋实验室主任、副主任受邀出席国庆庆祝大会',
          content: "南方海洋实验室主任陈大可院士、副主任张培震院士受邀参加中华人民共和国成立70周年庆祝大会。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/10.jpeg'),
          TimeTitle: '2019年10月12日至13日创新团队建设方案首次专家论证会',
          content: "召开首次创新团队建设方案专家论证会，15个创新团队的建设方案通过论证。创新团队将以“尊崇首创，力争最优”（to be the first or the best）为标准，聚焦海洋研究关键领域，产出标志性原创成果，为国家海洋强国战略提供重要支撑。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/11.jpeg'),
          TimeTitle: '2019年10月18日公共平台建设方案首次专家论证会',
          content: "召开首次公共平台建设方案专家论证会。海洋元素与同位素、海洋生物资源库、海洋科考、海上测试场等平台通过专家论证，正式启动建设。其中，和珠海云洲智能科技有限公司合作的无人船海上测试场是国内首个发起建设的海上测试场，第一期（2019-2020年）投入超过3.6亿元，计划于2020年3月投入使用。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/12.jpeg'),
          TimeTitle: '2019年10月18日南方海洋实验室主任陈大可成为珠海市首位顶尖人才',
          content: "珠海市副市长阎武向陈大可院士颁发了《珠海市高层次人才证书》。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/13.png'),
          TimeTitle: '2019年10月18日至10月20日“科技创新与未来海洋”全国博士后学术交流',
          content: "承办“科技创新与未来海洋”全国博士后学术交流活动在广东省珠海市顺利召开。本次活动吸引了海洋科学、海洋工程等领域200余位博士后、青年学者参加。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/14.png'),
          TimeTitle: '2019年11月1日粤港澳极地与深海科技创新青年学者论坛',
          content: "承办粤港澳极地与深海科技创新青年学者论坛，来自香港、澳门和内地极地与海洋领域的研究人员、青年学者100余人参会。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/15.jpeg'),
          TimeTitle: '2019年11月15日共建共享共赢——合作共建单位座谈会',
          content: "举行首批合作共建单位座谈会。实验室主任陈大可院士提出要秉承“共建共享共赢”原则，与各共建单位在创新团队和公共平台建设、重大创新项目开展、海洋后备人才联合培养等方面进行深度合作。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/16.png'),
          TimeTitle: '2019年11月22日南方海洋实验室戴永久教授当选中国科学院院士',
          content: "地球数值模拟技术创新团队核心成员戴永久教授当选中国科学院院士。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/17.jpeg'),
          TimeTitle: '2019年12月3日第二批合作共建单位签约仪式',
          content: "第二批合作共建单位包括香港、澳门、广东等地高校，以及国家海洋环境预报中心和相关企事业单位等14家。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/18.jpeg'),
          TimeTitle: '2019年12月15日中国首个国际智能船艇赛新闻发布会',
          content: "本次大赛拟邀请全球高校学生组队参加，以技术迭代和应用拓展为目标，具有以学致用、以研带产的实效意义，同时促进高校学生在科研领域的国际交流与合作。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/19.png'),
          TimeTitle: '2019年12月25日召开2019年度创新团队总结大会',
          content: "实验室团队成员共同创造了累累硕果，获批国家重点研发计划项目、国家自然科学基金、广东省科技计划等各类项目233项，其中国家级项目128项，省部级项目50项，累积科研经费33750.04万元。申请发明专利和实用新型专利29项，获得授权30项，发表论文379篇，其中SCI/EI收录344篇，专著总量3部，提交决策研究报告4篇。共获得19个奖项，其中国家级1项，国际、省部级及其他18项。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/20.png'),
          TimeTitle: '2019年12月30日第一届理事会第二次会议顺利召开',
          content: "科技部原部长徐冠华院士、中山大学校长罗俊院士、珠海市市长姚奕生等理事会成员出席了会议。理事会一致肯定了实验室2019年来的建设成果，并相信在主任陈大可院士的带领下，2020年实验室将迈上新台阶。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/21.png'),
          TimeTitle: '2020年3月18日谢伟副教授成为我国首个在南海1600米水深处，首次发现“鲸落”的科学家',
          content: "谢伟副教授在乘坐“深海勇士”号载人潜水器执行实验室深海生命与生态过程创新团队的“西太平洋典型海山生态系统的关键过程及驱动机制”重大深潜调查项目时，在南海1600米水深处，首次发现一具长约三米的“鲸落”。据了解，这是我国科学家第一次发现该类型的生态系统。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/22.png'),
          TimeTitle: '2020年8月16日召开2020年年中工作会议',
          content: "本次会议以“促进交流，凝聚共识”为主题，旨在进一步凝练标志性成果和亮点，加强创新团队之间的合作交叉，深化创新团队与平台的联系与合作。"
        },
        {
          imgs: require('../../assets/image/aboutUs/course/23.png'),
          TimeTitle: '2020年8月27日顺利举办 “海洋科考高峰论坛”',
          content: "此次论坛的举办，是以中山大学海洋科考实习船下水为契机，围绕我国的海洋科考工作，从多方面开展高峰对话。论坛采用线上线下两种形式召开，并同时进行了图文直播，实时浏览达到6000余人次。"
        },
      ],
      dataList_en: [
        {
          imgs: require('../../assets/image/aboutUs/course/1.jpeg'),
          TimeTitle: 'Construction officially started on November 14, 2018',
          content: "In order to thoroughly implement the spirit of General Secretary Xi Jinping's important speech on his visit to Guangdong and vigorously implement the innovation-driven development strategy, the Guangdong Provincial Party Committee and Government decided to build the Southern Marine Science and Engineering Guangdong Laboratory (Zhuhai)."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/2.jpeg'),
          TimeTitle: 'The unveiling ceremony was held on December 26, 2018',
          content: "The unveiling ceremony and the inaugural meeting of the council were held, and the first meeting of the first council of the Southern Ocean Laboratory was held. It was approved by the meeting that Chen Dake, an academician of the Chinese Academy of Sciences, will serve as the director of the laboratory, and Su Jilan, an academician of the Chinese Academy of Sciences, will serve as the director of the academic committee. The Southern Ocean Laboratory is organized by the Zhuhai Municipal People's Government. Sun Yat-sen University takes the lead in the construction and management, and implements the laboratory director responsibility system under the leadership of the council."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/3.jpeg'),
          TimeTitle: '7 March 2019 to promote the International Grand Science Program',
          content: "Hosted the preparatory meeting for the comprehensive scientific experiment of the South China Sea monsoon. A total of more than 120 people attended the meeting, including 7 academicians from the Chinese Academy of Sciences and Chinese Academy of Sciences and other experts and scholars from domestic and foreign units. This conference will provide previous successful experience and constructive strategies for the implementation of the South China Sea monsoon scientific experiment, and it is also the first international academic conference hosted by the Southern Ocean Laboratory."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/4.jpeg'),
          TimeTitle: 'The inaugural meeting of the first academic committee on April 7, 2019',
          content: "The inaugural meeting and the first meeting of the first academic committee of the Southern Ocean Laboratory, consisting of 19 academicians from the Chinese Academy of Sciences and the Chinese Academy of Engineering and 12 top experts in the marine field, were held in Zhuhai."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/5.jpeg'),
          TimeTitle: 'On June 3, 2019, the signing ceremony of the first batch of cooperative and co-construction units',
          content: "The signing ceremony of the first batch of co-construction units was held in Zhuhai. The first batch of contracts signed include 12 co-construction units including the Ministry of Natural Resources, the Ministry of Education and other ministries and commissions, scientific research institutes and universities. The laboratory will benchmark against the best, best and most advanced marine laboratories in the world and gather global innovative talents."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/6.jpeg'),
          TimeTitle: 'Continue to support the South China Sea scientific expedition plan from April to June 2019',
          content: "Successfully organized the \"Xisha Comprehensive Scientific Expedition Voyage\" and the \"South China Sea Monsoon Comprehensive Scientific Expedition and Test Rehearsal Voyage\". Among them, the Paracel voyage discovered a new marine insect on the Antelope Reef of the Paracel Islands, and named it Antelope Reef Sea Stinger. During the atmospheric flight, more than 100,000 sets of marine meteorological data were collected, and the data validity reached or exceeded 90%; more than 80,000 sets of physical ocean data were collected, and the expected observation results were achieved."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/7.png'),
          TimeTitle: 'On July 17, 2019, aboard the "Deep Sea Warrior" for a deep dive mission\'',
          content: "Associate Professor Su Ming and Associate Researcher He Jian participated in the TS12-02 voyage of \"Exploration No. 1\". They set off from Sanya, Hainan and headed to the northern and northwestern parts of the South China Sea. They took the \"Deep Sea Warrior\" submersible and successfully completed the deep diving mission."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/8.png'),
          TimeTitle: 'On September 20, 2019, the two field observation and research stations were approved',
          content: "The Southern Ocean Laboratory and Sun Yat-Sen University jointly established the \"Pearl River Estuary Marine Ecological Environment Ministry of Education's Field Scientific Observation and Research Station\", which was recognized by the Ministry of Education. On the 24th, the \"Field Scientific Observation and Research Station for Climate, Environment and Air Quality Changes Around the Pearl River Estuary\" was approved as the Guangdong Provincial Field Scientific Observation and Research Station."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/9.jpeg'),
          TimeTitle: 'On October 1, 2019, the director and deputy director of the Southern Ocean Laboratory were invited to attend the National Day Celebration Conference',
          content: "Academician Chen Dake, director of the Southern Ocean Laboratory, and academician Zhang Peizhen, deputy director, were invited to participate in the celebration of the 70th anniversary of the founding of the People's Republic of China."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/10.jpeg'),
          TimeTitle: 'From October 12th to 13th, 2019, the first expert demonstration meeting of the innovative team building plan',
          content: "The first expert demonstration meeting on innovative team construction plans was held, and the construction plans of 15 innovative teams passed the demonstration. The innovation team will take \"to be the first or the best\" as the standard, focus on key areas of marine research, produce iconic original results, and provide important support for the national strategy of strengthening the country's oceans."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/11.jpeg'),
          TimeTitle: 'On October 18, 2019, the first expert demonstration meeting of the public platform construction plan',
          content: "The first expert demonstration meeting on the construction plan of the public platform was held. Platforms such as marine elements and isotopes, marine biological resource bank, marine scientific research, and marine testing grounds have been officially launched after expert demonstrations. Among them, the unmanned ship offshore test field in cooperation with Zhuhai Yunzhou Intelligent Technology Co., Ltd. is the first offshore test field initiated and constructed in China. The first phase (2019-2020) has invested more than 360 million yuan and is planned to be launched in March 2020. Put into use."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/12.jpeg'),
          TimeTitle: 'On October 18, 2019, Chen Dake, director of the Southern Ocean Laboratory, became the first top talent in Zhuhai',
          content: "Yan Wu, Deputy Mayor of Zhuhai City, issued the \"Zhuhai City High-level Talent Certificate\" to Academician Chen Dake."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/13.png'),
          TimeTitle: 'October 18-20, 2019 National Postdoctoral Academic Exchange on "Technology Innovation and Future Ocean"',
          content: "Undertook the national post-doctoral academic exchange activity \"Science and Technology Innovation and Future Ocean\" was successfully held in Zhuhai City, Guangdong Province. The event attracted more than 200 postdoctoral fellows and young scholars from the fields of marine science and marine engineering."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/14.png'),
          TimeTitle: 'November 1, 2019 Guangdong-Hong Kong-Macao Polar and Deep Sea Technology Innovation Young Scholars Forum',
          content: "Undertook the Guangdong-Hong Kong-Macao Polar and Deep Sea Science and Technology Innovation Young Scholars Forum, with more than 100 researchers and young scholars from Hong Kong, Macao and the Mainland polar and ocean fields participating."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/15.jpeg'),
          TimeTitle: 'November 15, 2019 Co-construction, sharing and win-win - Symposium on cooperation and co-construction units',
          content: "The first batch of symposiums for cooperative and co-construction units were held. Academician Chen Dake, director of the laboratory, proposed to adhere to the principle of \"co-construction, sharing and win-win\", and conduct in-depth cooperation with various co-construction units in the construction of innovation teams and public platforms, the development of major innovation projects, and the joint training of marine reserve talents."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/16.png'),
          TimeTitle: 'On November 22, 2019, Professor Dai Yongjiu of the Southern Ocean Laboratory was elected as an academician of the Chinese Academy of Sciences',
          content: "Professor Dai Yongjiu, a core member of the Earth Numerical Simulation Technology Innovation Team, was elected as an academician of the Chinese Academy of Sciences."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/17.jpeg'),
          TimeTitle: 'On December 3, 2019, the signing ceremony of the second batch of cooperative co-construction units',
          content: "The second batch of cooperative co-construction units includes universities in Hong Kong, Macau, Guangdong and other places, as well as 14 national marine environmental forecasting centers and related enterprises and institutions."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/18.jpeg'),
          TimeTitle: 'December 15, 2019 China\'s first international smart boat race press conference',
          content: "This competition intends to invite college students from all over the world to form teams to participate, aiming at technology iteration and application expansion."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/19.png'),
          TimeTitle: 'The 2019 Innovation Team Summary Conference was held on December 25, 2019',
          content: "The team members of the laboratory have jointly created a lot of achievements, and have been approved for 233 national key R&D projects, the National Natural Science Foundation of China, and the Guangdong Provincial Science and Technology Plan, including 128 national-level projects and 50 provincial and ministerial-level projects. Accumulated scientific research The funding is 337.5004 million yuan. He has applied for 29 invention patents and utility model patents, obtained 30 authorizations, published 379 papers, of which 344 were indexed by SCI/EI, 3 monographs in total, and 4 decision-making research reports were submitted. A total of 19 awards have been won, including 1 at the national level and 18 at the international, provincial and ministerial levels."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/20.png'),
          TimeTitle: 'On December 30, 2019, the second meeting of the first council was successfully held',
          content: "Academician Xu Guanhua, former Minister of Science and Technology, Academician Luo Jun, President of Sun Yat-sen University, and Yao Yisheng, Mayor of Zhuhai City, attended the meeting. The council unanimously affirmed the laboratory's construction achievements in 2019, and believed that under the leadership of the director, Academician Chen Dake, the laboratory will reach a new level in 2020."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/21.png'),
          TimeTitle: 'On March 18, 2020, Associate Professor Xie Wei became the first scientist in China to discover a "whale fall" at a depth of 1,600 meters in the South China Sea',
          content: "Associate Professor Xie Wei took the \"Deep Sea Warrior\" manned submersible to carry out the \"Key Processes and Driving Mechanisms of the Typical Seamount Ecosystem in the Western Pacific\" major deep diving investigation project of the Deep Sea Life and Ecological Process Innovation Team of the Laboratory, 1600 meters in the South China Sea. In the depths of the water, a \"whale fall\" about three meters long was discovered for the first time. It is understood that this is the first time that Chinese scientists have discovered this type of ecosystem."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/22.png'),
          TimeTitle: 'The 2020 mid-year work conference was held on August 16, 2020',
          content: "With the theme of \"Promoting Exchange and Building Consensus\", this conference aims to further condense the landmark achievements and highlights, strengthen the cooperation and intersection between innovation teams, and deepen the connection and cooperation between innovation teams and the platform."
        },
        {
          imgs: require('../../assets/image/aboutUs/course/23.png'),
          TimeTitle: 'On August 27, 2020, the "Marine Scientific Research Summit Forum" was successfully held',
          content: "The forum was held with the launch of the Sun Yat-sen University marine scientific research practice ship as an opportunity to carry out summit dialogues from various aspects around my country's marine scientific research work. The forum was held in both online and offline forms, and at the same time, it was broadcast live with pictures and texts, and the real-time viewing reached more than 6,000 people."
        },
      ],
    }
  },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
  },
}
</script>

<style scoped lang="scss">
.mian-article {
  @include home_bg_t2_color();

  .width1200 {
    width: 100%;
    background-image: url("../../assets/image/aboutUs/bg.png");
    background-repeat: no-repeat;
    background-size: cover;

    .box {
      width: 1400px;
      height: 1118px;
      background-color: #FFFFFF;
      margin: 0 auto;
      padding: 58px 90px;
      box-sizing: border-box;
      overflow-y: auto;
    }

    @include co_white_to_black();

    h1 {
      text-align: center;
    }

    .site {
      display: flex;
    }

    .site-img {
      width: 240px;
      height: 160px;
    }

    .site-info {
      flex: 1;
      margin-left: 24px;
      text-indent: 2em;
    }
  }
}
</style>